import { UseQueryOptions } from '@tanstack/react-query';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';
import QueryKeys from './keys';
import { ContentType, ContentTypeEnumForBackend } from 'domains/content/types';
import { Folder } from 'models/types';

type UseContentWithFoldersParams = {
    folderId?: number;
    type?: string;
    searchTerm?: string;
    statuses?: string[];
    reactQueryOptions?: UseQueryOptions<Folder[], Error>;
};

const useContentWithFolders = ({
    folderId = -1,
    type,
    searchTerm,
    statuses,
    reactQueryOptions,
}: UseContentWithFoldersParams = {}) => {
    let apiType = type;
    if (type === ContentType.PAGE) {
        apiType = ContentTypeEnumForBackend['Landing Page'];
    }

    const params: Record<string, string> = {};
    if (type) {
        params.type = apiType;
    }
    if (searchTerm) {
        params.searchTerm = searchTerm;
    }
    if (statuses && statuses.length > 0) {
        params.status = statuses.join(',');
    }

    const axiosOptions = Object.keys(params).length > 0 ? { params } : {};

    const folderPath = folderId === -1 ? '' : folderId;

    return useQuery(
        QueryKeys.CONTENT(folderId, type, searchTerm, statuses?.join(',')),
        `${CuredApiPaths.CONTENT}/${folderPath}`,
        reactQueryOptions,
        axiosOptions
    );
};

export default useContentWithFolders;
